export function cbsWidget() {
    var $inputNew = $('#radio-1');
    var $inputUsed = $('#radio-2');
    var $radioActive = $('.radio.active');
    var $radioWrapper = $('.radio');
    var $chooseFormNew = $('.only-new');
    var $chooseFormUsed = $('.only-used');
    var $widgets = $('.widget-wrapper');
    var $sbmButton = $('.cars_form_submit');
    var $root = $('.root');
    var $currentView = $root.attr('id');
  
    // if (!$root.is("#page_index_index_shop-for-cars")) {
    //   $sbmButton.attr('value', 'Apply');
    // }
    $inputNew.on('click', function(){
      $chooseFormNew.addClass('active-form');
      $chooseFormUsed.removeClass('active-form');
      $radioWrapper.removeClass('active');
      $(this).closest('.radio').addClass('active');
      $('.only-new').find('select.cars_form_make').addClass('active-select');
      $('.only-used').find('select.cars_form_make').removeClass('active-select');
  
      $('.only-new').find('select.cars_form_model').addClass('active-select-second');
      $('.only-used').find('select.cars_form_model').removeClass('active-select-second');
  
      $('.only-new').find('input.active-disabled').addClass('active-disabled');
      $('.only-used').find('input.active-disabled').removeClass('active-disabled');
    });
  
    $inputUsed.on('click', function(){
      $chooseFormUsed.addClass('active-form');
      $chooseFormNew.removeClass('active-form');
      $radioWrapper.removeClass('active');
      $(this).closest('.radio').addClass('active');
      $('.only-used').find('select.cars_form_make').addClass('active-select');
      $('.only-new').find('select.cars_form_make').removeClass('active-select');
  
      $('.only-used').find('select.cars_form_model').addClass('active-select-second');
      $('.only-new').find('select.cars_form_model').removeClass('active-select-second');
  
      $('.only-used').find('input.active-disabled').addClass('active-disabled');
      $('.only-new').find('input.active-disabled').removeClass('active-disabled');
    });
  
    $widgets.each(function(index, widget) {
      var $widget = $('.widget-wrapper'),
          $sections = $widgets.find('section');
  
      $sections.each(function(index, section) {
        var $section = $(section),
        $form = $section.find('form'),
        formData = $form.data(),
        $cars_form_make = $form.find('.cars_form_make'),
        $cars_form_model = $form.find('.cars_form_model'),
        $cars_form_zip = $form.find('.cars_form_zip'),
        $cars_form_submit = $form.find('.cars_form_submit'),
        $hidden_field = $form.find('.hidden_field'),
        $hidden_field_place = $form.find('.hidden_field_place'),
        $urlParam;
  
        if ($currentView === 'page_index_index_shop-for-cars') {
          $hidden_field_place.val($currentView);
        }
  
        if ($(window).innerWidth() < 768) {
          $cars_form_zip.attr('placeholder', 'ZIP Code');
        }
  
        if ($section.hasClass('only-new')) {
          $urlParam = 0;
        } else if ($section.hasClass('only-used')) {
          $urlParam = 1;
        }
  
        $.fn.select2.defaults.set('language', {
          errorLoading: function() {
            return i18n.no_results;
          },
          loadingMore: function() {
            return i18n.loading;
          },
          noResults: function() {
            return i18n.no_results;
          },
          searching: function() {
            return i18n.loading;
          },
        });
  
        var selectData = $cars_form_make.data();
        connectDependentSelect2Fields($cars_form_make, $cars_form_model, 'alias', $cars_form_submit, {used: $urlParam });
  
        $cars_form_model.select2({
          placeholder: i18n.select_model
        }).on('select2:open', (function(event) {
          setTimeout(function(){ $('.select2-search input').blur()}, 1);
        }));
  
        function connectDependentSelect2Fields(
          $field,
          $dependentField,
          idProp,
          $submitBtn,
          dataParam
        ) {
          var selectData = $field.data();
          // if (selectData.alias) {
          //   if (selectData.ready || !selectData.url) return;
          //   $.ajax({
          //     url: selectData.url,
          //     dataType: 'json',
          //     data: dataParam,
          //     success: function (response, textStatus, jqXHR) {
          //       if (!response || response.constructor !== Object || !response.status)
          //         return;
  
          //       var items = $.map(response.items, function (item) {
          //         return {
          //           text: item.text,
          //           id: item[idProp],
          //         };
          //       });
  
          //       items.unshift({
          //         id: ' ',
          //         text: selectData.placeholder,
          //       });
  
          //       var val = $field.val();
          //       $field.empty().select2({data: items, id: 'id'});
  
          //       if (val) {
          //         $field.val(val);
          //       }
  
          //       setTimeout(() => {
          //         $field.val(selectData.alias).trigger('change');
          //       }, 100);
  
          //       $field.data('ready', true);
          //     },
          //   });
          //   if (selectData.alias && selectData.alias !== '') {
          //     var selectDataAdditional = $dependentField.data();
          //     //var selectDataAnother = $selectAnotherDependent.data();
  
          //     $submitBtn.attr('disabled', true);
          //     if (!selectData.url) return;
  
          //     var data = dataParam || {};
          //     data[idProp] = selectData.alias.indexOf('_') !== -1 ? selectData.alias.split('_')[0] : selectData.alias;
  
          //     $.ajax({
          //       url: selectDataAdditional.url,
          //       dataType: 'json',
          //       data: data,
          //       success: function (response, textStatus, jqXHR) {
          //         if (
          //           !response ||
          //           response.constructor !== Object ||
          //           !response.status
          //         )
          //           return;
  
          //         var items = $.map(response.items, function (item) {
          //           return {
          //             text: item.text,
          //             id: item[idProp],
          //           };
          //         });
  
          //         items.unshift({
          //           id: ' ',
          //           text: $dependentField.data('placeholder'),
          //         });
          //         $dependentField
          //           .empty()
          //           .select2({data: items})
          //           .prop('disabled', false)
          //           .data('ready', true);
  
          //         if (selectDataAdditional.submodel) {
          //           setTimeout(() => {
          //             $dependentField.val(selectData.submodel).trigger('change');
          //           }, 100);
          //         }
  
          //         $submitBtn.prop('disabled', '');
          //       },
          //     });
          //   }
          // } else
          if ($currentView === 'page_index_index_shop-for-cars') {
            $.ajax({
              url: selectData.url,
              dataType: 'json',
              data: {used: $urlParam },
              success: function (response, textStatus, jqXHR) {
                if (
                  !response ||
                  response.constructor !== Object ||
                  !response.status
                )
                  return;
  
                var items = $.map(response.items, function (item) {
                  return {
                    text: item.text,
                    id: item['alias'],
                  };
                });
  
                items.unshift({
                  id: ' ',
                  text: selectData.placeholder,
                });
  
                var val = $cars_form_make.val();
                $cars_form_make.empty().select2({data: items, id: 'id'});
  
                if (val) {
                  $cars_form_make.val(val);
                }
  
                $cars_form_make.data('ready', true);
                // $cars_form_make.select2('open');
              },
            });
          }
          $field
            .select2({
              placeholder: i18n.select_make,
              language: {
                errorLoading: function () {
                  return i18n.no_results;
                },
                loadingMore: function () {
                  return i18n.loading;
                },
                noResults: function () {
                  return i18n.no_results;
                },
                searching: function () {
                  return i18n.loading;
                },
              },
            })
            .on('select2:open', function (event) {
              // setTimeout(function () {
              //   $('.select2-search input').blur();
              // }, 1);
              // console.log('open worked');
            })
            .on('select2:opening', function () {
              var selectData = $field.data();
  
              if (selectData.ready || !selectData.url) return;
              if ($currentView !== 'page_index_index_shop-for-cars') {
                $.ajax({
                  url: selectData.url,
                  dataType: 'json',
                  data: dataParam,
                  success: function (response, textStatus, jqXHR) {
                    if (
                      !response ||
                      response.constructor !== Object ||
                      !response.status
                    )
                      return;
  
                    var items = $.map(response.items, function (item) {
                      return {
                        text: item.text,
                        id: item[idProp],
                      };
                    });
  
                    items.unshift({
                      id: ' ',
                      text: selectData.placeholder,
                    });
  
                    // var val = $field.val();
                    $field.empty().select2({data: items, id: 'id'});
  
                    // if (val) {
                    //   $field.val(val);
                    // }
  
                    $field.data('ready', true);
                    $field.select2('open');
                  },
                });
              }
            })
            .on('select2:select', function (event) {
              var $select = $(this),
                $selectAnother = $('.widget-wrapper').find('select.cars_form_make').not('.active-select'),
                $selectAnotherDependent = $('.widget-wrapper').find('select.cars_form_model').not('.active-select-second'),
                $submitBtnAnother = $('.widget-wrapper').find('input.cars_form_submit').not('.active-disabled'),
                value = $select.val();
  
              $selectAnother.val(value);
              // $selectAnother.trigger('change');
              var selectAnotherValue = $selectAnother.val();
  
              if (selectAnotherValue != null) {
                $selectAnother.trigger('change');
              } else {
                $submitBtnAnother.attr('disabled', true);
                $selectAnother.select2({
                  placeholder: "Select Make",
                  allowClear: true
                });
              }
  
              //value acura for example
              if (value && value !== ' ') {
                var selectData = $dependentField.data();
                //var selectDataAnother = $selectAnotherDependent.data();
  
                $submitBtn.attr('disabled', true);
                if (!selectData.url) return;
  
                var data = dataParam || {};
                data[idProp] = value.indexOf('_') !== -1 ? value.split('_')[0] : value;
  
                $.ajax({
                  url: selectData.url,
                  dataType: 'json',
                  data: data,
                  success: function (response, textStatus, jqXHR) {
                    if (
                      !response ||
                      response.constructor !== Object ||
                      !response.status
                    )
                      return;
  
                    var items = $.map(response.items, function (item) {
                      return {
                        text: item.text,
                        id: item[idProp],
                      };
                    });
  
                    items.unshift({
                      id: ' ',
                      text: $dependentField.data('placeholder'),
                    });
                    $dependentField
                      .empty()
                      .select2({data: items})
                      .prop('disabled', false)
                      .data('ready', true);
  
                    if (selectData.submodel) {
                      setTimeout(() => {
                        $dependentField.val(selectData.submodel).trigger('change');
                      }, 100);
                    }
  
                    $submitBtn.prop('disabled', '');
                  },
                });
  
                if ($currentView === 'page_index_index_shop-for-cars') {
                  if (selectAnotherValue && selectAnotherValue !== '') {
                    var selectDataAnother = $selectAnotherDependent.data();
                    if (!selectDataAnother.url) return;
  
                    var dataAnother = Object.assign({}, dataParam || {});
  
                    if (data.used == 0) {
                      dataAnother.used = 1;
                    } else if (data.used == 1) {
                      dataAnother.used = 0;
                    }
  
                    try {
                      dataAnother[idProp] = selectAnotherValue.indexOf('_') !== -1 ? selectAnotherValue.split('_')[0] : selectAnotherValue;
                    } catch (error) {
                      return;
                    }
  
                    $.ajax({
                      url: selectDataAnother.url,
                      dataType: 'json',
                      data: dataAnother,
                      success: function (response, textStatus, jqXHR) {
                        if (
                          !response ||
                          response.constructor !== Object ||
                          !response.status
                        )
                          return;
  
                        var items = $.map(response.items, function (item) {
                          return {
                            text: item.text,
                            id: item[idProp],
                          };
                        });
  
                        items.unshift({
                          id: ' ',
                          text: $selectAnotherDependent.data('placeholder'),
                        });
                        $selectAnotherDependent
                          .empty()
                          .select2({data: items})
                          .prop('disabled', false)
                          .data('ready', true);
  
                        if (selectDataAnother.submodel) {
                          setTimeout(() => {
                            $selectAnotherDependent.val(selectDataAnother.submodel).trigger('change');
                          }, 100);
                        }
  
                        $submitBtnAnother.prop('disabled', '');
                      },
                    });
                  }
                }
              } else {
                $dependentField
                  .val(' ')
                  .empty()
                  .trigger('change')
                  .prop('disabled', true);
                $submitBtn.attr('disabled', true);
              }
            });
          $dependentField
            .on('select2:select', function (event) {
              var $select = $(this),
                $selectAnotherDependent = $('.widget-wrapper').find('select.cars_form_model').not('.active-select-second'),
                $submitBtnAnother = $('.widget-wrapper').find('input.cars_form_submit').not('.active-disabled'),
                value = $select.val();
  
  
              $selectAnotherDependent.val(value);
              var selectAnotherValue = $selectAnotherDependent.val();
              if (selectAnotherValue != null) {
                $selectAnotherDependent.trigger('change');
              } else {
                // $submitBtnAnother.attr('disabled', true);
                $selectAnotherDependent.select2({
                  placeholder: "Select Model",
                  allowClear: true
                });
  
              }
            });
            $form.on('submit', function(event) {
              var make = $cars_form_make.val();
              var model = $cars_form_model.val();
              var zipCode = $cars_form_zip.val();
              var hiddenField = $hidden_field.val();
  
              if (hiddenField == 1) {
                hiddenField = 'New Cars Shoppers';
              } else {
                hiddenField = 'Used Cars Shoppers';
              }
  
              gtmDataLayer.push({
                  'event': 'TrueCarShop',
                  'vehicleShopper': hiddenField,
                  'vehicleMake': make,
                  'vehicleModel': model,
                  'userZip': zipCode
              });
            });
        }
      });
    });
}